import { render, staticRenderFns } from "./DocumentList.vue?vue&type=template&id=8eefea3a&lang=pug"
import script from "./DocumentList.vue?vue&type=script&lang=js"
export * from "./DocumentList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports